module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"matchToProceed":"Match to proceed"},"al":{"matchToProceed":"Përshtat për të vazhduar"}}')
  delete Component.options._Ctor
}
